import React from 'react'
import type { CSSProperties } from 'react'

import { cn } from '@utils/mergeClassNames'

interface SpinnerLoaderProps {
  className?: string
  label?: string
  size?: number
  style?: CSSProperties
}

/** For network requests and ordinary actions; AI work uses SparklesLoader. */
export function SpinnerLoader({
  className,
  label = 'Loading',
  size = 32,
  style,
}: SpinnerLoaderProps) {
  return (
    <span
      role={label ? 'status' : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
      className={cn('block shrink-0', className)}
      style={{ width: size, height: size, ...style }}
    >
      <svg
        className="block animate-spin"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke="currentColor"
          strokeWidth="3"
          opacity="0.2"
        />
        <path
          d="M12 3a9 9 0 0 1 9 9"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    </span>
  )
}
